import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "../utility/Utils";
import { createQueryString } from "../utility/helper";

export const contractTypesApi = createApi({
  reducerPath: "contractTypes",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL, // this base_Url is not found.
    prepareHeaders: (headers, { getState }) => {
      // Get the JWT token from the auth state
      const token = getToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["contractTypes", "contractTypesList"],
  endpoints: (builder) => ({
    // Read
    getContractTypes: builder.query({
      query: (params) => {
        const serializedParams = createQueryString(params);
        return `/hrm/contract-types?${serializedParams}`;
      },
      providesTags: ["contractTypes"],
      transformResponse: (response) => {
        return response?.data;
      },
    }),

    getContractTypesList: builder.query({
      query: () => {
        return `/hrm/contract-types/list`;
      },
      providesTags: ["contractTypesList"],
      transformResponse: (response) => {
        return response?.data;
      },
    }),

    // Create
    createContractType: builder.mutation({
      query: (data) => ({
        url: "/hrm/contract-types",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["contractTypes", "contractTypesList"],
    }),

    // Update
    updateContractTypes: builder.mutation({
      query: ({ data: contractTypes, id }) => ({
        url: `/hrm/contract-types/${id}`,
        method: "PATCH",
        body: contractTypes,
      }),
      invalidatesTags: ["contractTypes", "contractTypesList"],
    }),

    // Delete
    deleteContractTypes: builder.mutation({
      query: (id) => ({
        url: `/hrm/contract-types/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["contractTypes", "contractTypesList"],
    }),
  }),
});

export const {
  useCreateContractTypeMutation,
  useDeleteContractTypesMutation,
  useUpdateContractTypesMutation,
  useGetContractTypesQuery,
  useGetContractTypesListQuery,
} = contractTypesApi;
